// extracted by mini-css-extract-plugin
export default {"imgFooter":"Footer_imgFooter__Xj-88"};